// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30sjY","title":"styles_title__1TSrM"};